import { render, staticRenderFns } from "./sysMsg.vue?vue&type=template&id=5dc67996"
import script from "./sysMsg.vue?vue&type=script&lang=js"
export * from "./sysMsg.vue?vue&type=script&lang=js"
import style0 from "./sysMsg.vue?vue&type=style&index=0&id=5dc67996&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports